export default __webpack_public_path__ + "static/media/Hair_12_M_C3.59cb348b.svg";